import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import { useDispatch, useSelector } from "react-redux";
import {
  addQuotationh,
  getQtnJobList,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate } from "../../../../common/Validations";
import EntryModel from "./EntryModel";
import EntryUpdate from "./EntryUpdate";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DeleteQuotationJob from "./DeleteQuotationJob";

const EntryList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // const [getFileViewData, setFileViewData] = useState(null);
  let entryData = useSelector((state) => state?.customerV1?.quotation_Job); // User Details from Store
  let entryTable = useSelector(
    (state) => state?.customerV1?.quotation_Job?.pagination
  );
  const [data, setData] = useState();
  const [modalQuotation, setModalQuotationShowStatus] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [modalDeleteQuotationJob, setModalDeleteQuotationJob] = useState(false);
  const [getEntryListData, setEntryListData] = useState();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [userRole, setUserRole] = useState("");
  useEffect(() => {
    setUserRole(userData?.roles?.[0]?.roleId || "");
  }, [userData]);
  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const loadQuotationData = async () => {
    setData(entryData?.data);
  };

  const showCashRequestModal = () => {
    setModalQuotationShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalQuotationShowStatus(false);
  };
  const showUpdateModal = () => {
    setModalUpdate(true);
  };
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };

  const handleEditClick = (row) => {
    dispatch(addQuotationh(row));
    showUpdateModal("EDIT", row.documentNumber);
  };

  // Fetch Filtered Data
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_ENQUIRY_LIST",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getQtnJobList(obj));
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_ENQUIRY_LIST",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getQtnJobList(obj));
    setData(entryData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_ENQUIRY_LIST",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getQtnJobList(obj));
    setData(entryData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_ENQUIRY_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQtnJobList(obj));
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_ENQUIRY_LIST",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getQtnJobList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const entryList = [
    {
      name: "Reference Nr",
      id: "qtnReferenceNr",
      // dropDown: true,
      selector: (row) =>
        `${row?.jobReferenceNr || ""} - ${row?.qtnReferenceNr || ""}`,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobReferenceNr}
            {row.qtnReferenceNr}
          </span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Type",
      selector: (row) => row?.type,
      id: "type",
      dropDown: true,
      cell: (row) => (
        <>
          <span
            className={`bg-table-status ${
              row.type === "Quotation"
                ? "bg-table-warning-status"
                : row.type === "Job"
                ? "bg-table-success-status"
                : ""
            }`}
          >
            {row.type}
          </span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Edit",
      selector: (row) => row.documentNumber || "--",
      cell: (row) => (
        <div>
          <button
            className="btn d-flex align-items-center w-100"
            onClick={() => handleEditClick(row.documentNumber)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Company/Client",
      selector: (row) => row.clientName,
      id: "clientName",
      dropDown: false,
      cell: (row) => (
        <div>
          <p class="fw-bold">{row.clientName}</p>
          <p class="">{row.companyName}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Building Name",
      selector: (row) => row.buildingName,
      cell: (row) => (
        <div>
          <p className="">{row.buildingName} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Sales Officer",
      id: "salesOfficerName",
      dropDown: true,
      selector: (row) => row.salesOfficerName,
      cell: (row) => (
        <div>
          <p className=" ">{row.salesOfficerName} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Location",
      selector: (row) => row.location,
      id: "location",
      dropDown: false,
      cell: (row) => (
        <div>
          <p className=" ">{row.location} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Estimation Date",
      selector: (row) => row.estimationDate,
      id: "estimationDate",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{formatDate(row?.estimationDate)}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
     {
      name: "Created Date/Time",
      id: "createdAt",
      dropDown: true,
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div>
          {/* <p className=" ">{row.location} </p> */}
            <p className="d-block fw-bold">
  {new Date(row.createdAt).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })}
</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}
                  <strong>Remarks:</strong> {row?.remarks || "--"}
                  <br />
                  <strong>Job/Qtn Nr:</strong> {row?.documentNumber || "--"}
                  <br />
                  <strong>Entry Nr:</strong> {row?.enquiryNr || "--"}
                  <br />
                  Entry List
                  <strong>Created By:</strong> {row?.createdBy || "--"}
                  <br />
                  <strong>Created Name:</strong> {row?.createdName || "--"}
                  <br />
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "175px",
    },
    /*  {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteQuotaionJob(row)}>
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    }, */
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <button onClick={() => deleteQuotaionJob(row)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      sortable: true,
      width: "200px",
      omit: userRole !== "DESIGN-MANAGER",
    },
  ];

  const columnsForFilter = entryList
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //delete

  const deleteQuotaionJob = (data) => {
    setModalDeleteQuotationJob(true);
    setEntryListData(data);
  };

  const hideModal = () => {
    setModalDeleteQuotationJob(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">List Of Entries</h2>
                <p className="subText">List Of Entries</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LE</span>
                    </Col>
                    <Col xs={6} md={8} lg={8}>
                      <span className="headerTitle">List Entries</span>
                    </Col>

                    <Col xs={3} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => showCashRequestModal()}
                      >
                        Create
                      </button>
                    </Col>
                    {/* <Col xs={3} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={() => showCashRequestModal()}
                        // onClick={() => setShowUploadModal(true)}
                      >
                        Upload
                      </button>
                    </Col> */}
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span>
                              <i className="bi bi-download"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[2]}
                          leftOffsets={[0, 160]}
                        />
                        <DataTable
                          title=""
                          columns={entryList}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={entryTable?.total}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <EntryModel
        show={modalQuotation}
        onHide={() => hideModalStatus()}
        key={modalQuotation ? "open" : "closed"}
      />
      <EntryModel
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      />
      <EntryUpdate show={modalUpdate} onHide={() => hideUpdateModal()} />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        // fileid={getFileViewData}
      />
      <DeleteQuotationJob
        show={modalDeleteQuotationJob}
        onHide={() => hideModal()}
        data={getEntryListData}
        // dropdownData={getAccountGroup}
      />
    </main>
  );
};

export default EntryList;
